<template>
    <div>
        <Modal v-model="modalShow" :title="$t('opinions')" width="400px" @on-ok="save">
            <Input v-model="value" type="textarea" :rows="4" placeholder="" />
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            modalShow:false,
            value:''
        }
    },
    created(){
    },
    methods:{
        save(){
            this.$emit('ok',this.value)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/ApprovalRemark.vue